/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedQuantitySelect_item = {
    readonly defaultSkuId: string | null;
    readonly isSold: boolean | null;
    readonly isDeleted: boolean | null;
    readonly seller: {
        readonly status: string | null;
    } | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly quantity: number | null;
        readonly hasUnlimitedQuantity: boolean | null;
        readonly quantitySelectOptions: ReadonlyArray<{
            readonly label: string | null;
            readonly value: number | null;
        } | null> | null;
        readonly setSize: number | null;
    } | null> | null;
    readonly " $refType": "PdpSharedQuantitySelect_item";
};
export type PdpSharedQuantitySelect_item$data = PdpSharedQuantitySelect_item;
export type PdpSharedQuantitySelect_item$key = {
    readonly " $data"?: PdpSharedQuantitySelect_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedQuantitySelect_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedQuantitySelect_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultSkuId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDeleted",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "skus",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantity",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasUnlimitedQuantity",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "quantitySelectOptions",
          "storageKey": null,
          "args": null,
          "concreteType": "SkuQuantityOption",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "setSize",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '5ebe8c7f0f2a0fdd71545caa99b6f643';
export default node;
